export default __webpack_public_path__ + "static/media/marchWalk_thumb.9fe4abf5.png";